import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Staff } from '@/features/staff'
import { requireActiveSubscription } from '@/lib/middleware'

const staffSearchSchema = z.object({
  view: z.enum(['cards', 'list']).optional().catch('cards'),
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  search: z.string().optional().catch(''),
  sortBy: z.string().optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  // Legacy enum filter — kept so old links keep working (no UI emits it now).
  role: z.enum(['health_carer', 'support_coordinator', 'supported_employee']).optional(),
  // RBAC role filter: an org `roles.id` (the Role dropdown's option values).
  roleId: z.string().optional(),
  // Membership status. Absent = the server default (everything but offboarded).
  status: z
    .array(z.enum(['active', 'suspended', 'offboarded']))
    .optional()
    .catch([]),
})

export const Route = createFileRoute('/_authenticated/_organization/staff/')({
  beforeLoad: async () => requireActiveSubscription(),
  component: Staff,
  validateSearch: staffSearchSchema,
})
